module.exports = __webpack_public_path__ + "img/bg-scissors.9414ecc3.svg";